<div class="chat-page">
  <app-besharp-chat [service]="chatApiService" [config]="chatConfig" (sessionCreated)="onSessionCreated($event)">
    <ng-template #emptyStateTemplate let-emptyState>
      <div class="chat-empty-template">
        <div class="chat-empty-template__icon">
          <i [class]="emptyState.icon"></i>
        </div>
        <h3>{{ emptyState.title }}</h3>
        <p>{{ emptyState.description }}</p>
        @if (emptyState.suggestions?.length) {
          <div class="chat-empty-template__examples">
            <p>💡 Example:</p>
            <ul>
              @for (suggestion of emptyState.suggestions; track $index) {
                <li>{{ suggestion }}</li>
              }
            </ul>
          </div>
        }
      </div>
    </ng-template>
  </app-besharp-chat>
</div>
